import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CustomTool } from './customTool';
import * as React from 'react';
import { SectionStyle } from '../../../helpers/SectionStyle';

interface StackedBarChartHorizontalProps extends React.ClassAttributes<any> {
    data: any;
    YKey: string;
    XKey: string[];
    XTicks?: any[];
    YTicks?: any[];
    legend?: string[];
    unit?: string[];
    color?: string[];
    containerSize?: any;
    id?: string;
    setTitle?: (elem?: JSX.Element) => JSX.Element;
}

export interface StackedBarChartHorizontalState {
    containerKey: number
}


export class StackedBarChartHorizontal extends React.Component<StackedBarChartHorizontalProps, StackedBarChartHorizontalState> {

    constructor(props: any) {
        super(props);
        this.state = {
            containerKey: 0
        };
    }

    componentDidMount(): void {
        // WKETOOL-122: Problem bei Grafik
        // Dadurch erzwingen wir ein Update der Diagramme, um die Höhe erneut berechnen zu lassen.
        this.setState({ containerKey: this.state.containerKey + 1 });
    }

    render(): JSX.Element {
        const { data, XKey, YKey, XTicks, YTicks, legend, unit, containerSize } = this.props;

        if (!data) {
            return null;
        }
        const containerId: string = typeof SectionStyle.curPrintSectionId === 'number' ? SectionStyle.getCurrentClass(true) : null;
        const Section: any = new SectionStyle(containerId);
        const backgroundColorSectionChart: string = Section.getPropertyValue('--color-section-chart-background');
        const width = containerSize && containerSize.width ? containerSize.width : 600;
        const height = containerSize && containerSize.height ? containerSize.height : '100%';

        return <>
            {this.props.setTitle && this.props.setTitle()}
            <ResponsiveContainer
                key={`ResponsiveContainer_${this.state.containerKey}`}
                width={width}
                height={height}
                id={this.props.id}
            >
                <BarChart
                    data={data}
                    layout='vertical'
                    margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                >
                    <XAxis
                        type='number'
                        tickCount={0}
                        ticks={XTicks}
                        minTickGap={0}
                    />
                    <YAxis
                        dataKey={YKey}
                        type='category'
                        stroke='#888'
                        ticks={YTicks}
                        minTickGap={0}
                    />
                    <YAxis yAxisId='right' orientation='right' type='category' stroke='transparent' />
                    <Tooltip
                        content={((contentData: any) =>
                            <CustomTool
                                data={contentData}
                                dataKeys={XKey}
                                legendTitle={legend}
                                unit={unit}
                            />
                        )}
                        wrapperStyle={{
                            color: '#888',
                            backgroundColor: 'whitesmoke',
                            border: '1px solid #ccc',
                            padding: 5,
                            opacity: 0.9
                        }}
                    />
                    <Legend
                        align='center'
                        verticalAlign='top'
                        iconSize={10}
                        iconType='square'
                        wrapperStyle={{ paddingBottom: 7, color: '#555' }}
                    />
                    <CartesianGrid horizontal={false} stroke='#b0b0b0' fill={backgroundColorSectionChart} />
                    {this.renderBars()}
                </BarChart>
            </ResponsiveContainer>
        </>;
    }

    renderBars(): JSX.Element[] {
        const { XKey, data, legend, color } = this.props;
        const bars: JSX.Element[] = [];
        const barSize = Math.min(10, 100 / (Array.isArray(data) && data.length > 0 ? data.length : 1));
        (XKey || []).forEach((k: string, i: number) => {
            bars.push(
                <Bar
                    key={k}
                    dataKey={k}
                    fill={Array.isArray(color) && typeof color[i] === 'string' ? color[i] : null}
                    barSize={barSize}
                    stackId='stack'
                    name={Array.isArray(legend) && typeof legend[i] === 'string' ? legend[i] : k}
                    isAnimationActive={false}
                />
            );
        });
        return bars;
    }
}
